/* Free Shipping Progress Bar — custom build for So Buttery Skin.
 * Replaces the Essential Free Shipping app. Watches every cart mutation
 * (fetch + XHR) and re-reads /cart.js, so all bars on the page update live. */
(function () {
	'use strict';
	if (customElements.get('free-shipping-bar')) return;

	var MONEY_FORMAT = (window.theme && window.theme.moneyFormat) || '${{amount}}';
	var PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;

	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = precision == null ? 2 : precision;
		thousands = thousands || ',';
		decimal = decimal || '.';
		if (isNaN(number) || number == null) return '0';
		number = (number / 100).toFixed(precision);
		var parts = number.split('.');
		var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
		var cents = parts[1] ? decimal + parts[1] : '';
		return dollars + cents;
	}

	function formatMoney(cents, format) {
		var match = format.match(PLACEHOLDER);
		var key = match ? match[1] : 'amount';
		var value;
		switch (key) {
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break;
			default:
				value = formatWithDelimiters(cents, 2);
		}
		return match ? format.replace(PLACEHOLDER, value) : value;
	}

	function broadcast(cart) {
		if (!cart || typeof cart.total_price !== 'number') return;
		document.querySelectorAll('free-shipping-bar').forEach(function (el) {
			if (typeof el.update === 'function') el.update(cart);
		});
	}

	var refreshTimer = null;
	function refreshCart() {
		clearTimeout(refreshTimer);
		refreshTimer = setTimeout(function () {
			var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
			fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
				.then(function (r) { return r.ok ? r.json() : null; })
				.then(broadcast)
				.catch(function () {});
		}, 150);
	}

	function isCartMutation(url) {
		if (!url) return false;
		return /\/cart\/(add|change|update|clear)(\.js)?([/?]|$)/.test(String(url));
	}

	/* Watch fetch() — covers the theme's own cart requests */
	var _fetch = window.fetch;
	window.fetch = function () {
		var input = arguments[0];
		var url = input && input.url ? input.url : input;
		var promise = _fetch.apply(this, arguments);
		if (isCartMutation(url)) {
			promise.then(function (res) {
				if (res && res.ok) refreshCart();
			}).catch(function () {});
		}
		return promise;
	};

	/* Watch XMLHttpRequest — covers jQuery-based apps (quickview, upsells) */
	var _open = XMLHttpRequest.prototype.open;
	XMLHttpRequest.prototype.open = function (method, url) {
		if (isCartMutation(url)) {
			this.addEventListener('load', function () {
				if (this.status >= 200 && this.status < 300) refreshCart();
			});
		}
		return _open.apply(this, arguments);
	};

	/* Back/forward cache restores can show a stale cart */
	window.addEventListener('pageshow', function (e) {
		if (e.persisted) refreshCart();
	});
	/* Generic hook other scripts can use */
	document.addEventListener('cart:refresh', refreshCart);

	class FreeShippingBar extends HTMLElement {
		update(cart) {
			var threshold = parseInt(this.dataset.threshold, 10) || 0;
			var total = cart.total_price;
			var state;
			var pct;
			var html;

			if (total <= 0) {
				state = 'empty';
				pct = 0;
				html = (this.dataset.textEmpty || '').replace('{threshold}', this.dataset.thresholdLabel || '');
			} else if (total >= threshold) {
				state = 'unlocked';
				pct = 100;
				html = this.dataset.textUnlocked || '';
			} else {
				state = 'progress';
				pct = Math.max(1, Math.min(100, Math.floor((total / threshold) * 100)));
				var remaining = formatMoney(threshold - total, MONEY_FORMAT);
				html = (this.dataset.textProgress || '').replace('{amount}', '<strong>' + remaining + '</strong>');
			}

			this.dataset.state = state;
			this.classList.toggle('fsb--hidden', state === 'empty' && this.dataset.showEmpty !== 'true');

			var message = this.querySelector('.fsb__message');
			var fill = this.querySelector('.fsb__fill');
			var track = this.querySelector('.fsb__track');
			if (message) message.innerHTML = html;
			if (fill) fill.style.width = pct + '%';
			if (track) track.setAttribute('aria-valuenow', pct);
		}
	}

	customElements.define('free-shipping-bar', FreeShippingBar);
})();
